const PRODUCT_API_URL = (country = 'si', language = 'sl') =>
  process.env.REACT_APP_PRODUCT_API_URL ||
  // 'https://stage.productsearch.continental-tires.com/stage/continental/si/sl/plt/sbs?';
  // 'https://stage.productsearch.continental-tires.com/stage/continental/si/sl/plt/sbv?';
  `https://api.productsearch.continental-tires.com/v1/continental/${country}/${language}/plt/sbv?`;

export default PRODUCT_API_URL;

export const PRODUCT_API_HEADERS = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    // 'X-Api-Key': 'vzuaAG5Zahap0CzysiMcW6UPdDFXQTNm3i6FOtzM',
    'X-Api-Key': 'eln1kj8v4j1GTfrTxIbnr4sbE52nfRSu9DMoltTp',
  },
};